export default "__VITE_ASSET__Dl6sJWnZ__"